import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Note} from '../../classes/note';
import {NoteService} from '../../services/note';
import {GeneralModalComponent} from '../../modals/general/general-modal/general-modal.component';
import {RequestNoteCreateModalComponent} from '../../modals/request/request-note-create-modal/request-note-create-modal.component';

@Component({
    selector: 'app-request-notes',
    templateUrl: './request-notes.component.html',
    styleUrls: ['./request-notes.component.css']
})
export class RequestNotesComponent implements OnChanges {
    @Input() idRequest: number | undefined;
    @Output() notesCountChange = new EventEmitter<number>();

    notes: Array<Note> = [];
    creating = false;
    usernameFilterValue = '';
    creationDateFilterValue = '';
    lastModificationDateFilterValue = '';
    textFilterValue = '';
    editingNoteId: number | null = null;
    editingText = '';
    saving = false;

    constructor(private noteService: NoteService,
                private modalService: NgbModal) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['idRequest'] && this.idRequest) {
            this.loadNotes();
        }
    }

    loadNotes(): void {
        if (!this.idRequest) {
            return;
        }
        this.noteService.getAllByIDRequest(this.idRequest)
            .subscribe({
                next: (notes: Array<Note>) => {
                    this.notes = notes;
                    this.emitCount();
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    openCreateNoteModal(): void {
        if (!this.idRequest || this.creating) {
            return;
        }
        const modalRef = this.modalService.open(RequestNoteCreateModalComponent, { centered: true });
        modalRef.result.then((text: string) => {
            this.createNote(text);
        }, () => {});
    }

    startEdit(note: Note): void {
        this.editingNoteId = note.IDNote ?? null;
        this.editingText = note.Text;
    }

    cancelEdit(): void {
        this.editingNoteId = null;
        this.editingText = '';
    }

    saveNote(note: Note): void {
        const text = this.editingText.trim();
        if (!text || !note.IDNote || this.saving) {
            return;
        }
        this.saving = true;
        this.noteService.update({
            IDNote: note.IDNote,
            Text: text
        })
            .subscribe({
                next: (updatedNote: Note) => {
                    this.notes = this.notes.map(currentNote =>
                        currentNote.IDNote === updatedNote.IDNote ? updatedNote : currentNote
                    );
                    this.cancelEdit();
                    this.saving = false;
                },
                error: (err: HttpErrorResponse) => {
                    this.saving = false;
                    console.log(err);
                }
            });
    }

    openDeleteNoteModal(note: Note): void {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Cancellazione <strong>Nota</strong>';
        modalRef.componentInstance.text = 'Confermi la cancellazione di questa nota?';
        modalRef.result.then(() => {
            this.deleteNote(note);
        }, () => {});
    }

    private createNote(text: string): void {
        const noteText = (text || '').trim();
        if (!noteText || !this.idRequest || this.creating) {
            return;
        }
        this.creating = true;
        this.noteService.create({
            FKIDRequest: this.idRequest,
            Text: noteText
        })
            .subscribe({
                next: (note: Note) => {
                    this.notes = [...this.notes, note];
                    this.creating = false;
                    this.emitCount();
                },
                error: (err: HttpErrorResponse) => {
                    this.creating = false;
                    console.log(err);
                }
            });
    }

    private deleteNote(note: Note): void {
        if (!note.IDNote) {
            return;
        }
        this.noteService.delete(note.IDNote)
            .subscribe({
                next: () => {
                    this.notes = this.notes.filter(currentNote => currentNote.IDNote !== note.IDNote);
                    if (this.editingNoteId === note.IDNote) {
                        this.cancelEdit();
                    }
                    this.emitCount();
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    private emitCount(): void {
        this.notesCountChange.emit(this.notes.length);
    }
}
